// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YtfUd","leftSection":"styles_leftSection__GHidm","rightSection":"styles_rightSection__7sPRG","head":"styles_head__dogVk","bio":"styles_bio__ApXJo"};